import React, { useState } from 'react';
import { CalendarIcon, UsersIcon, LineChartIcon, LinkIcon, DatabaseIcon } from 'lucide-react';
import { Button } from './Button';
export function MeetingTabs() {
  const [activeTab, setActiveTab] = useState<'calendar' | 'attendees' | 'insights'>('calendar');
  return <div className="w-full bg-[#1A2331] rounded-xl overflow-hidden shadow-lg" data-id="element-361">
      {/* Tab Navigation */}
      <div className="flex border-b border-[#F5F7FA] border-opacity-10" data-id="element-362">
        <button onClick={() => setActiveTab('calendar')} className={`flex items-center px-6 py-4 text-sm font-medium ${activeTab === 'calendar' ? 'text-[#C8F169] border-b-2 border-[#C8F169]' : 'text-[#F5F7FA] text-opacity-70 hover:text-opacity-100'}`} data-id="element-363">
          <CalendarIcon className="mr-2 h-4 w-4" data-id="element-364" />
          Calendar
        </button>
        <button onClick={() => setActiveTab('attendees')} className={`flex items-center px-6 py-4 text-sm font-medium ${activeTab === 'attendees' ? 'text-[#C8F169] border-b-2 border-[#C8F169]' : 'text-[#F5F7FA] text-opacity-70 hover:text-opacity-100'}`} data-id="element-365">
          <UsersIcon className="mr-2 h-4 w-4" data-id="element-366" />
          Attendees
        </button>
        <button onClick={() => setActiveTab('insights')} className={`flex items-center px-6 py-4 text-sm font-medium ${activeTab === 'insights' ? 'text-[#C8F169] border-b-2 border-[#C8F169]' : 'text-[#F5F7FA] text-opacity-70 hover:text-opacity-100'}`} data-id="element-367">
          <LineChartIcon className="mr-2 h-4 w-4" data-id="element-368" />
          Insights
        </button>
      </div>
      {/* Tab Content */}
      <div className="p-6" data-id="element-369">
        {activeTab === 'calendar' && <CalendarTab data-id="element-370" />}
        {activeTab === 'attendees' && <AttendeesTab data-id="element-371" />}
        {activeTab === 'insights' && <InsightsTab data-id="element-372" />}
      </div>
    </div>;
}
function CalendarTab() {
  // Sample calendar events
  const events = [{
    id: 1,
    title: 'Product Demo with Acme Corp',
    time: '10:00 AM - 11:00 AM',
    date: 'Today',
    attendees: 4,
    status: 'Upcoming'
  }, {
    id: 2,
    title: 'Sales Pipeline Review',
    time: '1:00 PM - 2:00 PM',
    date: 'Today',
    attendees: 6,
    status: 'Upcoming'
  }, {
    id: 3,
    title: 'Strategic Planning with TechGiant',
    time: '3:30 PM - 4:30 PM',
    date: 'Today',
    attendees: 5,
    status: 'Upcoming'
  }];
  return <div data-id="element-373">
      <h3 className="text-xl font-semibold mb-4" data-id="element-374">Today's Schedule</h3>
      <div className="space-y-4" data-id="element-375">
        {events.map(event => <div key={event.id} className="bg-[#1E2A38] p-4 rounded-lg flex justify-between items-center" data-id="element-376">
            <div data-id="element-377">
              <h4 className="font-medium" data-id="element-378">{event.title}</h4>
              <div className="flex items-center text-sm text-[#F5F7FA] text-opacity-70 mt-1" data-id="element-379">
                <span data-id="element-380">{event.time}</span>
                <span className="mx-2" data-id="element-381">•</span>
                <span data-id="element-382">{event.attendees} attendees</span>
              </div>
            </div>
            <div data-id="element-383">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#C8F169] bg-opacity-20 text-[#C8F169]" data-id="element-384">
                {event.status}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}
function AttendeesTab() {
  // Sample attendees data
  const attendees = [{
    id: 1,
    name: 'Sarah Johnson',
    role: 'VP of Marketing',
    company: 'Acme Corp',
    email: 'sarah.johnson@acmecorp.com',
    linkedin: 'linkedin.com/in/sarahjohnson',
    bio: '15+ years experience in B2B marketing strategy and digital transformation',
    lastMeeting: '3 months ago'
  }, {
    id: 2,
    name: 'Michael Chen',
    role: 'Chief Technology Officer',
    company: 'Acme Corp',
    email: 'michael.chen@acmecorp.com',
    linkedin: 'linkedin.com/in/michaelchen',
    bio: 'Former Google engineer, specializes in AI and cloud infrastructure',
    lastMeeting: 'New contact'
  }, {
    id: 3,
    name: 'Alex Rodriguez',
    role: 'Procurement Manager',
    company: 'Acme Corp',
    email: 'alex.rodriguez@acmecorp.com',
    linkedin: 'linkedin.com/in/alexrodriguez',
    bio: 'Responsible for vendor selection and technology acquisitions',
    lastMeeting: '1 year ago'
  }];
  return <div data-id="element-385">
      <h3 className="text-xl font-semibold mb-4" data-id="element-386">Meeting Participants</h3>
      <div className="space-y-6" data-id="element-387">
        {attendees.map(attendee => <div key={attendee.id} className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-388">
            <div className="flex items-start justify-between mb-4" data-id="element-389">
              <div className="flex items-center" data-id="element-390">
                <div className="h-12 w-12 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] font-bold mr-4" data-id="element-391">
                  {attendee.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div data-id="element-392">
                  <h4 className="font-semibold text-lg" data-id="element-393">{attendee.name}</h4>
                  <p className="text-[#F5F7FA] text-opacity-70" data-id="element-394">
                    {attendee.role} at {attendee.company}
                  </p>
                </div>
              </div>
              <Button variant="secondary" className="flex items-center text-xs px-3 py-1" data-id="element-395">
                <DatabaseIcon className="h-3 w-3 mr-1" data-id="element-396" />
                Sync to CRM
              </Button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-397">
              <div data-id="element-398">
                <p className="text-[#F5F7FA] text-opacity-70 text-sm mb-1" data-id="element-399">
                  Email
                </p>
                <p data-id="element-400">{attendee.email}</p>
              </div>
              <div data-id="element-401">
                <p className="text-[#F5F7FA] text-opacity-70 text-sm mb-1" data-id="element-402">
                  LinkedIn
                </p>
                <a href={`https://${attendee.linkedin}`} target="_blank" rel="noopener noreferrer" className="text-[#C8F169] flex items-center" data-id="element-403">
                  View Profile <LinkIcon className="h-3 w-3 ml-1" data-id="element-404" />
                </a>
              </div>
            </div>
            <div className="mb-4" data-id="element-405">
              <p className="text-[#F5F7FA] text-opacity-70 text-sm mb-1" data-id="element-406">Bio</p>
              <p className="text-[#F5F7FA] text-opacity-90" data-id="element-407">{attendee.bio}</p>
            </div>
            <div className="flex items-center justify-between text-sm text-[#F5F7FA] text-opacity-70 pt-3 border-t border-[#F5F7FA] border-opacity-10" data-id="element-408">
              <span data-id="element-409">Last meeting: {attendee.lastMeeting}</span>
              <button className="text-[#C8F169]" data-id="element-410">View meeting history</button>
            </div>
          </div>)}
      </div>
    </div>;
}
function InsightsTab() {
  return <div className="space-y-8" data-id="element-411">
      {/* Opportunities Section */}
      <div data-id="element-412">
        <h3 className="text-xl font-semibold mb-4" data-id="element-413">Opportunities</h3>
        <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-414">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-415">
            <div data-id="element-416">
              <h4 className="font-medium text-[#C8F169] mb-2" data-id="element-417">
                Product Fit Analysis
              </h4>
              <p className="text-[#F5F7FA] text-opacity-90 mb-3" data-id="element-418">
                Acme Corp's current tech stack aligns with our integration
                capabilities. Their recent cloud migration creates an
                opportunity for our automation solutions.
              </p>
              <div className="flex items-center mt-2" data-id="element-419">
                <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2.5" data-id="element-420">
                  <div className="bg-[#C8F169] h-2.5 rounded-full" style={{
                  width: '85%'
                }} data-id="element-421"></div>
                </div>
                <span className="ml-2 text-sm font-medium" data-id="element-422">85% Match</span>
              </div>
            </div>
            <div data-id="element-423">
              <h4 className="font-medium text-[#C8F169] mb-2" data-id="element-424">
                Market Position
              </h4>
              <p className="text-[#F5F7FA] text-opacity-90 mb-3" data-id="element-425">
                Acme Corp is expanding their digital transformation initiatives
                with a focus on AI-driven analytics, aligning with our strategic
                offerings.
              </p>
              <div className="flex flex-wrap gap-2 mt-2" data-id="element-426">
                <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-[#F5F7FA] bg-opacity-10 text-[#F5F7FA]" data-id="element-427">
                  Digital Transformation
                </span>
                <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-[#F5F7FA] bg-opacity-10 text-[#F5F7FA]" data-id="element-428">
                  AI Integration
                </span>
                <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-[#F5F7FA] bg-opacity-10 text-[#F5F7FA]" data-id="element-429">
                  Data Analytics
                </span>
              </div>
            </div>
          </div>
          <div className="mt-6 pt-4 border-t border-[#F5F7FA] border-opacity-10" data-id="element-430">
            <h4 className="font-medium mb-2" data-id="element-431">Recommended Approach</h4>
            <ul className="space-y-2 text-[#F5F7FA] text-opacity-90" data-id="element-432">
              <li className="flex items-start" data-id="element-433">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#C8F169] mt-2 mr-2" data-id="element-434"></span>
                Focus on ROI metrics from similar implementations in their
                industry
              </li>
              <li className="flex items-start" data-id="element-435">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#C8F169] mt-2 mr-2" data-id="element-436"></span>
                Highlight integration capabilities with their existing
                Salesforce instance
              </li>
              <li className="flex items-start" data-id="element-437">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#C8F169] mt-2 mr-2" data-id="element-438"></span>
                Address data security concerns with our SOC 2 compliance
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Company Summary Section */}
      <div data-id="element-439">
        <h3 className="text-xl font-semibold mb-4" data-id="element-440">Company Summary</h3>
        <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-441">
          <div className="flex flex-col md:flex-row gap-6" data-id="element-442">
            <div className="md:w-2/3" data-id="element-443">
              <h4 className="font-medium mb-3" data-id="element-444">Acme Corporation</h4>
              <p className="text-[#F5F7FA] text-opacity-90 mb-4" data-id="element-445">
                Founded in 2005, Acme Corporation is a leading provider of
                enterprise software solutions with a focus on supply chain
                optimization and logistics management. The company serves over
                500 clients across manufacturing, retail, and distribution
                sectors.
              </p>
              <div className="grid grid-cols-2 gap-4" data-id="element-446">
                <div data-id="element-447">
                  <p className="text-[#F5F7FA] text-opacity-70 text-sm" data-id="element-448">
                    Industry
                  </p>
                  <p className="font-medium" data-id="element-449">Enterprise Software</p>
                </div>
                <div data-id="element-450">
                  <p className="text-[#F5F7FA] text-opacity-70 text-sm" data-id="element-451">
                    Headquarters
                  </p>
                  <p className="font-medium" data-id="element-452">Chicago, IL</p>
                </div>
                <div data-id="element-453">
                  <p className="text-[#F5F7FA] text-opacity-70 text-sm" data-id="element-454">
                    Employees
                  </p>
                  <p className="font-medium" data-id="element-455">1,200+</p>
                </div>
                <div data-id="element-456">
                  <p className="text-[#F5F7FA] text-opacity-70 text-sm" data-id="element-457">
                    Revenue
                  </p>
                  <p className="font-medium" data-id="element-458">$120M (2022)</p>
                </div>
              </div>
            </div>
            <div className="md:w-1/3 bg-[#1A2331] p-4 rounded-lg" data-id="element-459">
              <h4 className="font-medium mb-3" data-id="element-460">Market Statistics</h4>
              <div className="space-y-3" data-id="element-461">
                <div data-id="element-462">
                  <div className="flex justify-between text-sm mb-1" data-id="element-463">
                    <span className="text-[#F5F7FA] text-opacity-70" data-id="element-464">
                      Market Share
                    </span>
                    <span data-id="element-465">12.5%</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-466">
                    <div className="bg-[#C8F169] h-1.5 rounded-full" style={{
                    width: '12.5%'
                  }} data-id="element-467"></div>
                  </div>
                </div>
                <div data-id="element-468">
                  <div className="flex justify-between text-sm mb-1" data-id="element-469">
                    <span className="text-[#F5F7FA] text-opacity-70" data-id="element-470">
                      Growth Rate
                    </span>
                    <span data-id="element-471">+18.3% YoY</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-472">
                    <div className="bg-[#C8F169] h-1.5 rounded-full" style={{
                    width: '18.3%'
                  }} data-id="element-473"></div>
                  </div>
                </div>
                <div data-id="element-474">
                  <div className="flex justify-between text-sm mb-1" data-id="element-475">
                    <span className="text-[#F5F7FA] text-opacity-70" data-id="element-476">
                      Customer Retention
                    </span>
                    <span data-id="element-477">94%</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-478">
                    <div className="bg-[#C8F169] h-1.5 rounded-full" style={{
                    width: '94%'
                  }} data-id="element-479"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 pt-4 border-t border-[#F5F7FA] border-opacity-10" data-id="element-480">
            <h4 className="font-medium mb-3" data-id="element-481">Recent News</h4>
            <ul className="space-y-2" data-id="element-482">
              <li className="flex items-start" data-id="element-483">
                <span className="text-[#C8F169] mr-2" data-id="element-484">•</span>
                <div data-id="element-485">
                  <p className="text-[#F5F7FA] text-opacity-90" data-id="element-486">
                    Announced partnership with Microsoft for cloud integration
                    (2 months ago)
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-487">
                <span className="text-[#C8F169] mr-2" data-id="element-488">•</span>
                <div data-id="element-489">
                  <p className="text-[#F5F7FA] text-opacity-90" data-id="element-490">
                    Opened new R&D center focused on AI and machine learning (4
                    months ago)
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-491">
                <span className="text-[#C8F169] mr-2" data-id="element-492">•</span>
                <div data-id="element-493">
                  <p className="text-[#F5F7FA] text-opacity-90" data-id="element-494">
                    Acquired DataSync Technologies for $45M to enhance data
                    analytics capabilities (6 months ago)
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}